import React from "react";
import { Card, CardHeader, CardBody } from "reactstrap";

const BatchProgressCard = ({ batchLoading, activeTasksCount, batchCode }) => {
  if (!batchLoading) return null;

  return (
    <Card>
      <CardHeader>
        <h5 className="mb-0">
          <i className="ri-bar-chart-line me-2"></i>
          Batch Processing
        </h5>
      </CardHeader>
      <CardBody className="text-center py-5">
        <h6>
          Processing 
            <>
              <strong style={{ color: "#2F9E37" }}> {activeTasksCount}</strong>{" "} jobs
               under batch code {batchCode}.
            </>
        </h6>
        <p className="text-muted">This may take a few moments</p>
      </CardBody>
    </Card>
  );
};

export default BatchProgressCard;